import { Avatar } from '@mui/material';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useSessionContext } from './session.context';

import type {} from '@mui/material/themeCssVarsAugmentation';
import { MenuItem, MenuItemStateProps } from '@src/components';

const UserMenu: FC<MenuItemStateProps> = ({ isMini = false }) => {
  const { contactName, initial } = useSessionContext();
  const { COLORS } = useTheme();

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: contactName,
        icon: (
          <Avatar
            sx={{
              width: 24,
              height: 24,
              fontSize: 14,
              bgcolor: COLORS.primary.main,
              fontWeight: 'bold',
            }}
          >
            {initial}
          </Avatar>
        ),
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={false}
    />
  );
};

export { UserMenu };
